<template>
    <b-btn class="e-btn-social-login" @click="showLoading()" :href="loginUrl" :disabled="loading" :variant="provider.variant" :size="size" :class="[type, provider.classes]" :block="block">
        <template v-if="!loading">
            <slot name="icon" v-if="!noIcon">
                <i class="mr-2" :class="provider.icon"></i>
            </slot>
            <slot v-if="!noText">
                <template v-if="useShortText">
                    <span>{{provider.name}}</span>
                </template>
                <template v-else>
                    <span>{{provider.text}}</span>
                </template>
            </slot>
        </template>
        <template v-else>
            <slot name="loading">
                <i class="mr-2 fas fa-spinner-third fa-spin"></i>
                <slot v-if="!noText">
                    <span v-tr>Loading...|Chargement...</span>
                </slot>
            </slot>
        </template>
    </b-btn>
</template>

<script>
    import Network from "../helpers/Network.js";

    export default {
        name: `e-btn-social-login`,
        props: {
            apiBaseUrl: {type: String, default: `/user/social-login`}, // will be replaced with login-with-facebook login-with-google...
            callbackRoute: {type: String, default: `/social-login`}, // will be replaced with login-with-facebook login-with-google...
            size: {type: String, default: ``},
            type: {type: String, default: `facebook`},
            noIcon: {type: Boolean},
            useShortText: {type: Boolean},
            noText: {type: Boolean},
            block: {type: Boolean}
        },
        data() {
            return {
                loading: false,
                providers: {
                    facebook: {
                        name: `Facebook`,
                        icon: `fab fa-facebook`,
                        text: this.tr(`Sign in with Facebook|Se connecter avec Facebook`),
                        variant: `facebook`,
                        classes: ``
                    }
                }
            }
        },
        computed: {
            loginUrl() {
                return `${window.env.VUE_APP_API_URL}${this.apiBaseUrl}/${this.type}/${window.location.host}`;
            },
            provider() {
                if (this.providers[this.type]) {
                    return this.providers[this.type];
                } else {
                    return {};
                }
            }
        },
        methods: {
            hideLoading() {
                this.loading = false;
            },
            showLoading() {
                this.loading = true;
            },
            clicked() {
                Network.post(`${this.apiBaseUrl}-with-${this.type}`)
                    .then(resp => {
                        this.$emit(`success`, resp.data);
                    })
                    .catch(err => {
                        this.showErrorMessage(null, err);
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
.btn.e-btn-social-login {
    &.facebook {
        color: white;
        background-color: #4267B2;
    }
}
</style>
